var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCaretDownCyan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.81 1.06L5.78 6.092.75 1.061 1.81 0l3.97 3.97L9.75 0l1.06 1.06z",
    fill: "#00BAC7"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iNyIgdmlld0JveD0iMCAwIDExIDciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTAuODEwNyAxLjA2MDY2TDUuNzgwMzMgNi4wOTA5OUwwLjc1IDEuMDYwNjZMMS44MTA2NiAxLjA1ODgzZS0wOEw1Ljc4MDMzIDMuOTY5NjdMOS43NSAwTDEwLjgxMDcgMS4wNjA2NloiIGZpbGw9IiMwMEJBQzciLz4KPC9zdmc+Cg==";
export { SvgIconCaretDownCyan as ReactComponent };